<template>
<div class="broadcast">
  <div class="innerTop">
    <div class="left">
      <div>Going back to hub</div>
      <div class="leftInner">
        <el-switch
          v-model="backHub"
          inactive-text="On"
          active-color="#82D237"
          @change="changeStatus('bach')"
          inactive-color="#CCCCCC">
        </el-switch>
      </div>
    </div>
    <div class="left change">
<!--      <div class="inner" @click="refreshDriver">-->
<!--        Refresh driver list-->
<!--      </div>-->
<!--      <div>Task being delivered</div>-->
<!--      <div class="leftInner">-->
<!--        <el-switch-->
<!--          v-model="taskBe"-->
<!--          inactive-text="On"-->
<!--          active-color="#82D237"-->
<!--          @change="changeStatus('taskBe')"-->
<!--          inactive-color="#CCCCCC">-->
<!--        </el-switch>-->
      </div>
  </div>
  <el-scrollbar style="height: calc(100vh - 200px);margin-top: 20px;width: 100%"  v-loading="driverLoading">
    <div class="innerBtom">
      <div class="table" style="font-weight: bold" >
        <div>Driver</div>
        <div>Actions</div>
      </div>
      <div class="table" v-for="(item,index) in driverList" :key="index" >
        <div>{{item.name}}</div>
        <div>
          <el-switch
            v-model="item.is_broadcast"
            inactive-text="On"
            active-text=""
            active-color="#82D237"
            @change="changeStatus(item)"
            inactive-color="#CCCCCC">
          </el-switch>
        </div>
      </div>
    </div>
  </el-scrollbar>

</div>
</template>

<script>
import {
  changeBroadcastDriver,
  changeBroadcastList,
  getBroadcastList,
  getDriverBroadList,
  refreshDriverList
} from "@/api/broadcast";

export default {
  name: "broadcast",
  data(){
    return{
      backHub:false,
      taskBe:false,
      driverLoading:false,
      driverList:[],
    }
  },
  created() {
    this.driverLoading = true
    this.getFirstList()
    getBroadcastList().then(res=>{
      this.backHub = res.data[0].going_back_to_hub == 1? true:false
      this.taskBe =res.data[0].task_being_delivered  == 1? true:false
    })
  },
  methods:{
    getFirstList(){
      getDriverBroadList().then(res=>{
        this.driverLoading = false
        res.data.forEach((i,index)=>{
          i.is_broadcast = i.is_broadcast == 1 ? true:false
        })
        this.driverList = res.data
      })
    },
    //刷新司机列表
    refreshDriver(){
      this.driverLoading = true
      refreshDriverList().then(res=>{
          if (res.code == 200){
            this.getFirstList()
            this.$message({
              message: res.msg,
              type: 'success'
            });
          }else {
            this.$message({
              message: res.msg,
              type: 'error'
            });
          }
      }).catch(err=>{
        this.$message({
          message: err.msg,
          type: 'error'
        });
      })
    },
    changeStatus(e){
      if (e == 'bach' || e == 'taskBe'){
        let status = null
        if (e == 'bach'){
          status = this.backHub == true ? 1:0
          changeBroadcastList({
            going_back_to_hub:status,
          }).then(res=>{
            if (res.code = 200) {
              // this.$message({
              //   message: res.msg,
              //   type: 'success'
              // });
            }else {
              this.$message({
                message: res.msg,
                type: 'error'
              });
            }
          }).catch(err=>{
            this.$message({
              message: err.msg,
              type: 'error'
            });
          })
        }else {
          status = this.taskBe == true ? 1:0
          changeBroadcastList({
            task_being_delivered:status,
          }).then(res=>{
            if (res.code = 200){
              // this.$message({
              //   message: res.msg,
              //   type: 'success'
              // });
            }else {
              this.$message({
                message: res.msg,
                type: 'error'
              });
            }
          }).catch(err=>{
            this.$message({
              message: err.msg,
              type: 'error'
            });
          })
        }
      }else{
        changeBroadcastDriver({
          id:e.id,
          is_broadcast:e.is_broadcast == true? 1:0
        }).then(res=>{
          if (res.code = 200){
            // this.$message({
            //   message: res.msg,
            //   type: 'success'
            // });
          }else {
            this.$message({
              message: res.msg,
              type: 'error'
            });
          }
        }).catch(err=>{
          this.$message({
            message: err.msg,
            type: 'error'
          });
        })
      }
    }
  }
}
</script>

<style scoped lang="less">
.broadcast{
  .innerTop{
    width: 100%;
    height: 64px;
    line-height: 64px;
    background: #FFFFFF;
    border-radius: 16px;
    border: 1px solid #E0E0E0;
    display: flex;
    justify-content: space-between;
    .left{
      padding: 0 48px;
      width: 50%;
      display: flex;
      justify-content: space-between;
      .leftInner{
      }
    }
    .change{
      flex-direction: row-reverse;
      margin-top: 16px;
      height: 32px;
      padding: 0;
      .inner{
        cursor: pointer;
        color: #FFFFFF;
        font-size: 14px;
        line-height: 32px;
        width: 155px;
        background: #1F2D42;
        border-radius: 16px;
        margin-right: 16px;
      }
    }
  }
  .innerBtom{
    //width: 100%;
    //overflow: auto;
    font-size: 14px;
    margin: 20px 0;
    background: #FFFFFF;
    border-radius: 16px;
    .table{
      font-weight: normal;
      width: calc(100% - 92px);
      height: 56px;
      line-height: 56px;
      display: flex;
      justify-content: space-between;
      padding: 0 46px;
      box-shadow: inset 0px -1px 0px 0px #E0E0E0;
    }
    .last{
      box-shadow: none;
    }
  }
}
</style>
